import {
	AddBayPolesMutation,
	AddSubLocationMutation,
	BatchDeleteSiteLocationsMutation,
	CombineSubLocationsMutation,
	DeleteSiteLocationMutation,
	InactivateSiteLocationMutation,
	InactivateSubLocationMutation,
	MergeSiteLocationMutation,
	RemoveSubLocationMutation,
	RevertSubLocationCombineMutation,
	SetLocationDefaultSpaceTypeMutation,
	SetSiteContactsMutation,
	SetSiteLocationCoordinatesMutation,
	SetSiteTimeZoneMutation,
	UpdateSubLocationMutation
} from "~/gql/mutations/siteLocation.generated";
import {
	GetLocationInUseQuery,
	GetSiteLocationQuery,
	GetSiteLocationsQuery,
	GetSiteLocationTypeRelationshipsQuery,
	GetSubLocationCombinePreviewQuery,
	GetSubLocationQuery,
	GetSubLocationsQuery
} from "~/gql/queries/siteLocation.generated";

export const siteLocationEndpoints = {
	AddBayPoles: {
		invalidatesTags: ["SiteLocation"] as AddTagTypes,
		transformResponse: (res: AddBayPolesMutation) => res
	},
	AddSubLocation: {
		invalidatesTags: ["SiteLocation"] as AddTagTypes,
		transformResponse: (res: AddSubLocationMutation) => res
	},
	BatchDeleteSiteLocations: {
		invalidatesTags: ["SiteLocation"] as AddTagTypes,
		transformResponse: (res: BatchDeleteSiteLocationsMutation) => res
	},
	DeleteSiteLocation: {
		invalidatesTags: ["SiteLocation"] as AddTagTypes,
		transformResponse: (res: DeleteSiteLocationMutation) => res
	},
	GetLocationInUse: {
		providesTags: ["SiteLocation"] as AddTagTypes,
		transformResponse: (res: GetLocationInUseQuery) => res
	},
	GetSiteLocation: {
		providesTags: ["SiteLocation"] as AddTagTypes,
		transformResponse: (res: GetSiteLocationQuery) => res
	},
	GetSiteLocations: {
		providesTags: ["SiteLocation"] as AddTagTypes,
		transformResponse: (res: GetSiteLocationsQuery) => res
	},
	GetSiteLocationTypeRelationships: {
		providesTags: ["SiteLocation"] as AddTagTypes,
		transformResponse: (res: GetSiteLocationTypeRelationshipsQuery) => res
	},
	GetSubLocation: {
		providesTags: ["SiteLocation"] as AddTagTypes,
		transformResponse: (res: GetSubLocationQuery) => res
	},
	GetSubLocationCombinePreview: {
		providesTags: ["SiteLocation"] as AddTagTypes,
		transformResponse: (res: GetSubLocationCombinePreviewQuery) => res
	},
	GetSubLocations: {
		providesTags: ["SiteLocation"] as AddTagTypes,
		transformResponse: (res: GetSubLocationsQuery) => res
	},
	CombineSubLocations: {
		invalidatesTags: ["SiteLocation"] as AddTagTypes,
		transformResponse: (res: CombineSubLocationsMutation) => res
	},
	InactivateSiteLocation: {
		invalidatesTags: ["SiteLocation"] as AddTagTypes,
		transformResponse: (res: InactivateSiteLocationMutation) => res
	},
	InactivateSubLocation: {
		invalidatesTags: ["SiteLocation"] as AddTagTypes,
		transformResponse: (res: InactivateSubLocationMutation) => res
	},
	MergeSiteLocation: {
		invalidatesTags: ["SiteLocation"] as AddTagTypes,
		transformResponse: (res: MergeSiteLocationMutation) => res
	},
	RemoveSubLocation: {
		invalidatesTags: ["SiteLocation"] as AddTagTypes,
		transformResponse: (res: RemoveSubLocationMutation) => res
	},
	RevertSubLocationCombine: {
		invalidatesTags: ["SiteLocation"] as AddTagTypes,
		transformResponse: (res: RevertSubLocationCombineMutation) => res
	},
	SetLocationDefaultSpaceType: {
		invalidatesTags: ["SiteLocation"] as AddTagTypes,
		transformResponse: (res: SetLocationDefaultSpaceTypeMutation) => res
	},
	SetSiteContacts: {
		invalidatesTags: ["SiteLocation"] as AddTagTypes,
		transformResponse: (res: SetSiteContactsMutation) => res
	},
	SetSiteLocationCoordinates: {
		invalidatesTags: ["SiteLocation"] as AddTagTypes,
		transformResponse: (res: SetSiteLocationCoordinatesMutation) => res
	},
	SetSiteTimeZone: {
		invalidatesTags: ["SiteLocation"] as AddTagTypes,
		transformResponse: (res: SetSiteTimeZoneMutation) => res
	},
	UpdateSubLocation: {
		invalidatesTags: ["SiteLocation"] as AddTagTypes,
		transformResponse: (res: UpdateSubLocationMutation) => res
	}
};
